// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(s) {
  switch (s) {
    case "deactivated" :
        return /* Deactivated */4;
    case "deleted" :
        return /* Deleted */3;
    case "pending" :
        return /* Pending */0;
    case "rejected" :
        return /* Rejected */2;
    case "scheduled" :
        return /* Scheduled */1;
    default:
      return ErrorUtils$Catalyst.raiseError("CampaignModificationStatus.re", "Invalid Status", s);
  }
}

export {
  fromString ,
  
}
/* No side effect */
